module.exports = __webpack_public_path__ + "assets/microsoft-httpapi.535f21a7.svg";